<script setup>
import CanvasOrganism from '@/components/organisms/CanvasOrganism.vue';
import { useCanvas } from '@/composables/canvas';
import { defineProps, defineEmits } from 'vue';

const props = defineProps(["question"])
const emit = defineEmits(["result", "done"])

const canvasStore = useCanvas()

import { useOpenAIMultiModalClient } from './../../composables/openAI';
import { ref } from 'vue';

const {
  analyzeBase64Image
} = useOpenAIMultiModalClient();


const result = ref("")
const showResult = ref(false)

const Check = () => {

  emit("done")

  const promt = `Du bist ein OCR Assistent. Du sollst aus dem Bild den Text auslesen. Du sollst keine Fehler korregieren. Antworte mit dem folgenden JSON.

{
  "text": "OCR Ergebnis"  
}
`

  analyzeBase64Image(canvasStore.asBASE64(), "image/png", promt).then(value => {
    const genericRegex = /^```.*\s*|\s*```$/gm;
    const clean = value.replace(genericRegex, "");
    let res = JSON.parse(clean)
    emit("result", res.text)
  })
}


</script>

<template>

  <div class="container">
    <div class="word">
      {{ props.question.word }}
    </div>
    <div class="canvas">
      <canvas-organism class="canvas"></canvas-organism>
    </div>
  </div>


  <div class="result" v-if="showResult">
    {{ result }}
  </div>

  <div class="buttons">
    <div class="button secondary" @click="canvasStore.clear()">Löschen</div>
    <div class="button secondary">Abspielen</div>
    <div class="button success" @click="Check()">Fertig</div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.result {
  position: absolute;
  left: calc(50vw - 200px);
  top: calc(50vh - 200px);
  background-color: white;

  width: 400px;
  height: 400px;
}

.container {
  width: 100%;
  height: 100%;

  display: flex;
  overflow: hidden;
  flex-direction: column;

  .word {
    height: 100%;
    font-size: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(0, 0, 0, 0.6);
    margin-left: 40px;
  }


  .buttons {
    position: absolute;
    right: var(--spacing-xl);
    bottom: var(--spacing-xl);
    display: flex;

    .button {
      width: calc(var(--spacing-lg)*4);
      height: calc(var(--spacing-lg)*4);

      display: flex;
      align-items: center;
      justify-content: center;

      border-radius: calc(var(--spacing-lg)*2);
      font-size: var(--font-size-lg);

      margin-left: var(--spacing-lg);


      &.success {
        color: var(--color-text-dark);
        background-color: var(--color-status-success);

        &:active {
          opacity: 0.8;
          box-shadow: 0px 0px 10px var(--shadow-primary);
        }
      }

      &.secondary {
        color: var(--color-accent);
        background-color: var(--color-secondary);

        &:active {
          opacity: 0.8;
          box-shadow: 0px 0px 10px var(--shadow-primary);

        }
      }

    }
  }

}
</style>
